import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS: ReadonlyArray<{ label: string; href: string }> = [
  { label: "Om", href: "#about" },
  { label: "Foredrag", href: "#speaking" },
  { label: "Undervisning", href: "#teaching" },
  { label: "Publikasjoner", href: "#publications" },
  { label: "Prosjekter", href: "#projects" },
];

/** Flyter inn etter hero-seksjonen. Kompakt, dempet og med tydelig CTA. */
export function StickyNav() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > window.innerHeight * 0.55);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!shown) return null;

  return (
    <motion.nav
      aria-label="Seksjonsnavigasjon"
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="bg-bg/70 supports-[backdrop-filter]:bg-bg/55 fixed inset-x-0 top-0 z-40 border-b border-line backdrop-blur"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-3 md:px-10 lg:px-16">
        <a
          href="#top"
          className="font-mono text-xs uppercase tracking-widest text-muted hover:text-fg focus-visible:text-fg focus-visible:outline-none"
        >
          per-arne.no
        </a>
        <ul className="hidden items-center gap-6 font-mono text-xs uppercase tracking-widest text-muted md:flex">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="hover:text-accent focus-visible:text-accent focus-visible:outline-none"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="#speaking"
          className="border border-accent bg-accent px-3 py-2 font-mono text-[0.65rem] uppercase tracking-widest text-bg transition hover:bg-transparent hover:text-accent focus-visible:bg-transparent focus-visible:text-accent focus-visible:outline-none md:px-4"
        >
          Bestill
        </a>
      </div>
    </motion.nav>
  );
}
